"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var mapAddressNew = function mapAddressNew(address) {
  var _address$email, _address$firstname, _address$lastname, _address$postcode, _address$city, _address$country, _address$telephone, _address$company, _address$vat_id;
  var isCartFetcher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    email: (_address$email = address.email) !== null && _address$email !== void 0 ? _address$email : "",
    isCompany: !!(address.company && address.vat_id),
    firstName: (_address$firstname = address.firstname) !== null && _address$firstname !== void 0 ? _address$firstname : "",
    lastName: (_address$lastname = address.lastname) !== null && _address$lastname !== void 0 ? _address$lastname : "",
    street: address.street,
    postalCode: (_address$postcode = address.postcode) !== null && _address$postcode !== void 0 ? _address$postcode : "",
    city: (_address$city = address.city) !== null && _address$city !== void 0 ? _address$city : "",
    country: isCartFetcher ? {
      id: address === null || address === void 0 ? void 0 : address.country_id
    } : (_address$country = address.country) === null || _address$country === void 0 ? void 0 : _address$country[0],
    phone: (_address$telephone = address.telephone) !== null && _address$telephone !== void 0 ? _address$telephone : "",
    companyName: (_address$company = address.company) !== null && _address$company !== void 0 ? _address$company : "",
    vatId: (_address$vat_id = address.vat_id) !== null && _address$vat_id !== void 0 ? _address$vat_id : ""
  };
};
var _default = mapAddressNew;
exports["default"] = _default;